/* eslint no-console: 0 */
let RavenPromise;

export const configureBrowserSentry = () => {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }
  RavenPromise = import(/* webpackChunkName: "raven-js" */ 'raven-js');
  RavenPromise.then(Raven => {
    Raven.config(window.__SENTRY_ADDRESS__, {
      whitelistUrls: [
        /*
         * Only enable errors from scripts running on www.refinery29.com
         * (or www.mybox.cloud.rf29.net)
         */
        window.location.hostname
      ]
    }).install();
  });
};

export const captureException = (error) => {
  RavenPromise && RavenPromise.then(Raven => {
    Raven.captureException(error);
  });
  console.error(error);
};

export const captureMessage = (message) => {
  RavenPromise && RavenPromise.then(Raven => {
    Raven.captureMessage(message);
  });
  console.error(message);
};
